<section class="finished-card">
	<div class="card shadow">
		<div class="card-body">
			<div class="py-3 intro text-center">
				<h1 class="font-weight-bold">Oeps! Hier ging iets gruwelijk mis...
				<small>De pagina die je zocht bestaat niet.</small></h1> <p><a href="https://jongerenstemtest.nl">keer terug naar de homepagina en begin opnieuw!</a></p>

				<div class="embed-responsive embed-responsive-16by9">
					<iframe class="embed-responsive-item" src="https://giphy.com/embed/A05Zkc18G0tb2"  frameBorder="0" allowFullScreen></iframe>
				</div>
			</div>
		</div>   
	</div>  
</section>
